import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    text: {
        color: Theme.secondaryTextColor,
        textAlign: 'center',
        fontSize: Theme.primaryFontSize
    }
};

export default StyleSheet.create(baseStyles);
